import ShadowScroller from './ShadowScroller';

export default ShadowScroller;
